import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { CustomerProgress } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ArableCustomerService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-service/organisation/`;

  getCustomerProgress(year: number): Observable<CustomerProgress> {
    return this.http.get<CustomerProgress>(`${this.baseUrl}customerprogress/${year}`).pipe(
      map((d) => d),
      catchError(() => of(undefined)),
    );
  }

  upsertCustomerProgress(customerProgress: CustomerProgress) {
    return this.http.post<{ id: number }>(`${this.baseUrl}customerprogress`, customerProgress);
  }
}
